import { useEffect, type RefObject } from 'react';

export function useFocusShortcut<T extends HTMLInputElement | HTMLTextAreaElement>(
  ref: RefObject<T | null>,
) {
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      const isFindShortcut =
        (event.metaKey || event.ctrlKey) &&
        !event.shiftKey &&
        !event.altKey &&
        event.key.toLowerCase() === 'f';
      if (!isFindShortcut) return;
      event.preventDefault();
      const element = ref.current;
      if (!element) return;
      element.focus();
      element.select();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [ref]);
}
